(() => {
  if (window.leobelaRecentlyViewedInitialized) return;

  window.leobelaRecentlyViewedInitialized = true;

  // Card markup is cached, so bump this whenever its interactive structure changes.
  const STORAGE_KEY = 'leobela:recently-viewed:v2';
  const DEFAULT_LIMIT = 8;

  const readProducts = () => {
    try {
      const storedProducts = JSON.parse(
        window.localStorage.getItem(STORAGE_KEY) || '[]'
      );

      if (!Array.isArray(storedProducts)) return [];

      return storedProducts.filter(
        (item) =>
          item &&
          typeof item.handle === 'string' &&
          typeof item.html === 'string'
      );
    } catch (error) {
      return [];
    }
  };

  const writeProducts = (products) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      // Recently viewed products remain optional if storage is unavailable.
    }
  };

  const saveCurrentProduct = () => {
    const productTemplate = document.querySelector(
      'template[data-leobela-recently-viewed-card]'
    );

    if (!productTemplate) return;

    const handle = productTemplate.dataset.productHandle;
    const url = productTemplate.dataset.productUrl;
    const html = productTemplate.innerHTML.trim();

    if (!handle || !html) return;

    const products = readProducts().filter(
      (item) => item.handle !== handle
    );

    products.unshift({
      handle,
      url,
      html,
      viewedAt: Date.now(),
    });

    writeProducts(products.slice(0, DEFAULT_LIMIT));
  };

  const createCard = (storedProduct, sectionId, index) => {
    const template = document.createElement('template');

    template.innerHTML = storedProduct.html.trim();

    const card = template.content.querySelector(
      '[data-leobela-recently-viewed-item]'
    );

    if (!card) return null;

    card.id = `Slide-${sectionId}-${index + 1}`;

    return card;
  };

  const renderSection = (section) => {
    const sliderComponent = section.querySelector('slider-component');
    const productList = section.querySelector(
      '[data-leobela-recently-viewed-list]'
    );

    if (!sliderComponent || !productList) return;

    const sectionId = section.dataset.sectionId;
    const excludedHandle = section.dataset.excludeHandle || '';
    const requestedLimit = Number.parseInt(section.dataset.limit, 10);
    const limit = Number.isFinite(requestedLimit)
      ? requestedLimit
      : DEFAULT_LIMIT;

    const products = readProducts()
      .filter((item) => item.handle !== excludedHandle)
      .slice(0, limit);

    const fragment = document.createDocumentFragment();

    products.forEach((storedProduct, index) => {
      const card = createCard(storedProduct, sectionId, index);

      if (card) fragment.appendChild(card);
    });

    productList.replaceChildren(fragment);

    const renderedCount = productList.children.length;

    if (renderedCount === 0) {
      section.hidden = true;
      return;
    }

    section.hidden = false;

    const controls = section.querySelector(
      '.leobela-recently-viewed__controls'
    );
    const progress = section.querySelector(
      '.leobela-recently-viewed__progress'
    );

    if (renderedCount < 2) {
      controls?.setAttribute('hidden', '');
      progress?.setAttribute('hidden', '');
    } else {
      controls?.removeAttribute('hidden');
      progress?.removeAttribute('hidden');
    }

    window.requestAnimationFrame(() => {
      if (typeof sliderComponent.resetPages === 'function') {
        sliderComponent.resetPages();
      }
    });
  };

  const initialize = () => {
    saveCurrentProduct();

    document
      .querySelectorAll('[data-leobela-recently-viewed-root]')
      .forEach(renderSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
